import { HttpError, sendAuthorizedRequest, aiResponseError } from './httpClient.js'

const JSON_OBJECT_DELIMITER = 'jsonobjectdelimiter'

export const requestOpenAI = async ({
  messages,
  attachments,
  aiVersion,
  tools,
  useOwnAiKey,
  streamText = false,
  returnReader = false,
  signal,
  promptCacheKey
}) => {
  if (!messages || messages.length === 0) {
    throw new Error('Cannot make AI call with empty messages.')
  }

  const CHAT_API_URL = process.env.VUE_APP_CHAT_API_URL
  const requestBody = {
    aiVersion,
    messages,
    attachments,
    tools,
    useOwnAiKey,
    streamText,
    promptCacheKey
  }

  const requestHeaders = {
    'Content-Type': 'text/plain;charset=UTF-8'
  }

  try {
    const response = await sendAuthorizedRequest(
      CHAT_API_URL,
      'POST',
      requestHeaders,
      JSON.stringify(requestBody),
      signal
    )

    let rawText
    if (!streamText && !returnReader) {
      rawText = await response.text()
    }

    if (!streamText && !returnReader && !rawText?.includes(JSON_OBJECT_DELIMITER)) {
      const response = JSON.parse(rawText)
      if (response?.error?.message) {
        throw aiResponseError(response.error)
      }
    }

    if (returnReader) {
      if (!response.body) {
        throw new Error('Response body is null, cannot return reader.')
      }
      return response.body.getReader()
    }

    if (rawText.trim() === '') {
      return null
    }
    const parts = rawText.split(JSON_OBJECT_DELIMITER).filter((part) => part.trim() !== '')
    if (parts.length === 0) {
      return null
    }
    const parsedResponse = JSON.parse(parts[0])
    if (parsedResponse?.message && parsedResponse.message.includes('Failed to parse AI response')) {
      throw new Error(parsedResponse.message)
    }

    return parsedResponse
  } catch (error) {
    if (error.name === 'AbortError' || error.userKeyRejected || error.aiError) {
      throw error
    }

    if (error instanceof HttpError) {
      console.error('AI request failed:', error.status, error.body)

      throw new Error('The AI service is temporarily unavailable. Please try again.')
    }

    throw error
  }
}
